






























































































import { Component,  Vue } from 'vue-property-decorator';
import { InvestmentData, Translate, ChangeActiveGIdEvent, OptionsItem } from "@/interfaces/IInvestment.interface";
import dropdown from '@/components/vue-dropdowns';
import Makieta from "@/components/Makieta.vue";


//import investmentJSON from '@/assets/sloneczne.json';
@Component({
    components: {
        Makieta,
        dropdown
    }
})

export default class Investment extends Vue {
    private dataJson: InvestmentData[] = [];
    private isLoading = false;
    private investmentIndex = '';
    private readonly statusTranslate: Translate[] = [
        { key: 'available', title: 'Dostupné/y'},
        { key: 'sold', title: 'Predáva/y'},
        { key: 'reserved', title: 'Rezervované/y'}
    ];

    private readonly segmentOptions: OptionsItem[] = [
        { gid: 'gr-1', name: "Segment 1" },
        { gid: 'gr-2', name: "Segment 2" },
        { gid: 'gr-3', name: "Segment 3" },
        { gid: 'gr-4', name: "Segment 4" },
        { gid: 'gr-5', name: "Segment 5" },
    ];

    constructor() {
        super();
        this.fetchJsonData();
    }
    data () {
        return {
           dataJson: [],
           //dataJson: investmentJSON,
        }
    }

    fetchJsonData() {
        const baseURI = '/modules/custom/ekobud_investment/assets/sloneczne-sk.json';
        Vue.axios.get(baseURI).then((response) => {
            if (typeof response.data !== "undefined") {
                this.dataJson = response.data;
                this.dataJson.sort( (a: InvestmentData, b: InvestmentData ) => ( a.title > b.title ) ? 1 : ( ( b.title > a.title ) ? -1 : 0 ) );
            }
        });
    }

    onChangeSelect( payload: OptionsItem ) {
        if ( !this.isLoading ) {
            this.isLoading = true;
            this.setLoading( payload.gid );
        }
    }

    onChangeActive( $event: ChangeActiveGIdEvent ): void {
        if ( !this.isLoading ) {
            this.isLoading = true;
            this.setLoading($event.gid);
        }
    }

    displaySuffix(num: number): boolean {
        return parseInt(num.toString()) > 0 ? true : false;
    }

    numberFormat(num: number, desktop = true ): string {
        let pow = (num > 0 ) ? '~' + parseInt(num.toString()).toString() : '';
        if (desktop) {
            pow = num.toString();
        }
        return pow;
    }

    priceFormat(num: string, format = 'desktop'): string {
        //const price = (num !== '' ) ? parseInt(num.split(' ').join('')) : 0;
        const price = (num !== '' ) ? parseInt(num.replace(/[ .]/g,'')) : 0;
        if (format === 'mobile') {
            return (price / 1000).toString() + 'tys';
        } else {
            return num;
        }

    }

    setLoading(gid: string): void {
        setTimeout(() => {
            this.isLoading = false;
            this.investmentIndex = gid;
            }, ((Math.random() * 1000) + 1000) );
    }

    translateStatus(key: string): string {
        const trans = this.statusTranslate.find( (trans) => trans.key === key);
        return (typeof trans !== "undefined")? trans.title : '';
    }

    get investmentData(): InvestmentData[] {
        return this.dataJson.filter( (row) => row.field_igropu === this.investmentIndex );
    }

}
